const EntranceAnimation = {
    elements: [],

    init() {
        if( this.cacheDom() ) {
            this.bindEvents()
        }
    },

    cacheDom() {
        this.elements = document.querySelectorAll('[data-entrance-animation]');
        return this.elements.length > 0;
    },

    bindEvents() {
        this.elements.forEach(element => {
            this.entrance(element);
        });
    },

    entrance(element) {
        const intersectionObserver = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        element.classList.add('is-visible');
                        intersectionObserver.unobserve(element);
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px 0px -100px 0px',
                threshold: 0,
            }
        );
    
        intersectionObserver.observe(element);
    }
}

export default EntranceAnimation;